import {createAction, props} from "@ngrx/store";

export const addMultiselectValue = createAction(
  '[Jobs Filter] Add Multiselect Value',
  props<{ key: string, value: any }>()
);

export const toggleJobFilterValue = createAction(
  '[Jobs Filter] Toggle Job Filter',
  props<{ key: string, value: any }>()
);

export const toggleSelectedRequirement = createAction(
  '[Jobs Filter] Toggle Selected Requirement',
  props<{ requirementId: number }>()
);

export const toggleSelectedSchoolSubject = createAction(
  '[Jobs Filter] Toggle Selected School Subject Id',
  props<{ schoolSubjectId: number }>()
);
export const toggleSelectedProviderType = createAction(
  '[Jobs Filter] Toggle Selected Provider Type',
  props<{ providerType: number }>()
);

export const setJobFilter = createAction(
  '[Jobs Filter] Set Job Filter',
  props<{ key: string, value: any }>()
);

export const setFilteredProfessionsNumber = createAction(
  '[Jobs Filter] Set Filtered Professions Number',
  props<{value: number}>()
);

export const setFilteredProvidersNumber = createAction(
  '[Jobs Filter] Set Filtered Providers Number',
  props<{value: number}>()
);

export const setFilteredJobsNumber = createAction(
  '[Jobs Filter] Set Filtered Jobs Number',
  props<{value: number}>()
);

export const setFilteredRookieNumber = createAction(
  '[Jobs Filter] Set Filtered Rookie Number',
  props<{value: number}>()
);

export const setUpdateArchiveView = createAction(
  '[Jobs Filter] Set Update Archive View',
  props<{updateActive: boolean}>()
);

export const resetFilterByKey = createAction(
  '[Jobs Filter] Set Filtered Professions Number',
  props<{key: string}>()
);

export const resetFiltersByEntity = createAction(
  '[Filter] Reset all filters by entity',
  props<{key: 'allProfession' | 'allProvider' | 'allJob' | 'allRookie'}>()
);

export const resetJobFilter = createAction(
  '[Jobs Filter] Reset Job Filter'
);

// Dropped when the rookie district changes: school, time slot, provider and profession ids are
// only meaningful inside the district they were picked in.
export const resetRookieDistrictScopedFilters = createAction(
  '[Filter] Reset rookie filters scoped to a district'
);

// Dropped when the RookieDay district changes: the school id is only meaningful inside the
// district it was picked in. Separate from the rookie action above — the two areas keep their
// own district and must not reset each other's filters.
export const resetRookieDayDistrictScopedFilters = createAction(
  '[Filter] Reset rookieday filters scoped to a district'
);
